import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Guide } from '../guide';
import { CKEDITORCONFIG } from '../ckeditor-config';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-guide-edit',
  templateUrl: './guide-edit.component.html',
  styleUrls: ['./guide-edit.component.css']
})
export class GuideEditComponent implements OnInit {

  guideForm!: FormGroup;
  selectedGuide!: Guide;
  nameIsNull = false;

  editorConfig: any = CKEDITORCONFIG;

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    let guideId = parseInt(this.route.snapshot.paramMap.get("guideId")!);
    this.httpService.getGuideById(guideId)
    .subscribe(res => {
      this.selectedGuide = res;
      this.guideForm = this.builder.group({
        name: this.selectedGuide.name,
        comment: this.selectedGuide.comment ? this.selectedGuide.comment : ""
      });
    });
  }

  sendForm(){
    this.nameIsNull = false;
    if(this.guideForm.value.name == ""){
      this.nameIsNull = true;
    }
    this.selectedGuide.name = this.guideForm.value.name;
    this.selectedGuide.comment = this.guideForm.value.comment;

    this.httpService.putGuide(this.selectedGuide).subscribe(res => {
      this.selectedGuide = res;
      console.log("success");
      this.addSuccess("updated", "guide is successfully updated.");
    }, error => {
      this.addError("error", "update failed...")
      console.error(error);
    });
  }

  deleteGuide(){
    if(confirm("Are you sure to delete this guide?")){
      this.httpService.deleteGuideById(this.selectedGuide.id!)
      .subscribe(() => {
        this.addSuccess("deleted", "successfully deleted");
        this.router.navigateByUrl("/management/guides");
      }, error => {
        this.addError("delete failed", "this couldn't be deleted.");
      });
    }
  }

  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

}
